/**
 * Remote-control command strings shared across web, mobile, and TV players.
 */
export const DEVICE_CMD = {
  play: "play",
  pause: "pause",
  stop: "stop",
  next: "next",
  previous: "previous",
  setVolume: "set_volume",
  setMute: "set_mute",
  shuffle: "shuffle",
  playNow: "play_now",
  addToQueue: "add_to_queue",
  removeFromQueue: "remove_from_queue",
  reorderQueue: "reorder_queue",
  getQueue: "get_queue",
  setSchedule: "set_schedule",
  forceSync: "force_sync",
  restart: "restart",
  clearCache: "clear_cache",
  seek: "seek",
  logout: "logout",
  quit: "quit",
} as const;

export type DeviceCommandName = (typeof DEVICE_CMD)[keyof typeof DEVICE_CMD];
